import React from 'react';

import './main.scss';

import appImage from './images/app.png';
import playStoreImage from './images/playstore.png';
import appStoreImage from './images/appstore.png';
import Header from './components/Header';
import Section from './components/Section';

function App() {
  return (
    <div className="app">
      <Header />
      <Section id="home" fillVertically>
        <div className="container">
          <div className="home">
            <div className="home__screenshot">
              <img alt="Madam Curious App" src={appImage} />
            </div>
            <div className="home__content">
              <div className="home__details">
                <div className="subtitle mgn-b">
                  Teaching Children to Think
                </div>
                <p className="content mgn-b">
                  For middle-schoolers to build critical thinking and problem
                  solving skills in science.&nbsp;
                  <a href="https://www.madamcurious.com">Learn more</a>
                </p>
              </div>
              <div className="home__actions">
                <div className="home__action">
                  <a
                    href="https://play.google.com/store/apps/details?id=school.humble.madam_curious"
                    target="_blank"
                  >
                    <img alt="Play Store Link" src={playStoreImage} />
                  </a>
                </div>
                <div className="home__action">
                  <a
                    href="https://apps.apple.com/us/app/madam-curious/id1464114406"
                    target="_blank"
                  >
                    <img alt="App Store Link" src={appStoreImage} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}

export default App;
